import React from 'react';
import css from './SectionPrizesOfMonth.css';

const withImgixSharpness = url => {
    if (!url) return url;
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}dpr=2&auto=format&q=80&fit=crop&w=564&h=376`;
};

export default ({ logo, inStock, total, onCardClick }) => (
    <div className={css.prize} onClick={onCardClick}>
        <div
            className={css.logoHolder}
            style={
                logo
                    ? {
                          backgroundImage: `url(${withImgixSharpness(logo)})`,
                      }
                    : {}
            }
        />
        <div>
            <div className={css.progressBar}>
                <div
                    style={{
                        width: `${(inStock * 100) / total}%`,
                        transition: '1s',
                    }}
                />
            </div>
            <p className={css.inStockInfo}>
                {!inStock || inStock < 1 ? (
                    <span>
                        <b>Gewinn vollständig vergeben</b>
                    </span>
                ) : (
                    <span>
                        <b>Noch {inStock}</b> von {total} Stück zu gewinnen
                    </span>
                )}
            </p>
        </div>
    </div>
);
